// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1n8kX","title":"ClientReferral_title__2eOsE","itemText":"ClientReferral_itemText__23a2y"};